var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgThemeDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    stroke: "none",
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27 18.79C26.8427 20.4922 26.2039 22.1144 25.1583 23.4668C24.1127 24.8192 22.7035 25.8458 21.0957 26.4265C19.4879 27.0073 17.748 27.1181 16.0795 26.7461C14.411 26.3741 12.883 25.5345 11.6742 24.3258C10.4655 23.117 9.62596 21.589 9.25393 19.9205C8.8819 18.252 8.99274 16.5121 9.57348 14.9043C10.1542 13.2965 11.1809 11.8874 12.5332 10.8418C13.8856 9.79614 15.5078 9.15731 17.21 9C16.2134 10.3483 15.7339 12.0094 15.8586 13.6814C15.9832 15.3534 16.7039 16.9251 17.8894 18.1106C19.075 19.2961 20.6466 20.0168 22.3186 20.1415C23.9906 20.2662 25.6518 19.7866 27 18.79Z",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThemeDark);
export default __webpack_public_path__ + "static/media/theme-dark.67a4fd72de2d2798bf25687c43572623.svg";
export { ForwardRef as ReactComponent };